const flowers = [
    "Alpine Sea Holly", 
    "Anthurium", 
    "Artichoke", 
    "Azalea",
    "Ball moss", 
    "Balloon flower",
    "Barbeton daisy",
    "Bearded Iris",
    "Bee Balm",
    "Bird of Paradise",
    "Bishop of Llandaff",
    "Black-eyed Susan",
    "Blackberry Lily", 
    "Blanket flower",
    "Bolero Deep Blue",
    "Bougainvillea",
    "Bromelia",
    "Buttercup",
    "California Poppy",
    "Camellia",
    "Canna Lily",
    "Canterbury Bells",
    "Cape flower",
    "Carnation",
    "Cautleya spicata",
    "Clematis", 
    "Colt's foot", 
    "Columbine",
    "Common dandelion",
    "Corn poppy",
    "Cyclamen",
    "Daffodil",
    "Desert Rose",
    "English Marigold",
    "Fire lily",
    "Foxglove",
    "Frangipani",
    "Fritillary",
    "Garden Phlox",
    "Gaura",
    "Gazania",
    "Geranium",
    "Giant White Arum lily",
    "Globe flower",
    "Globe Thistle",
    "Grape Hyacinth",
    "Great Masterwort",
    "Hard-leaved Pocket Orchid",
    "Hibiscus",
    "Hippeastrum",
    "Japanese Anemone",
    "King protea", 
    "Lenten Rose",
    "Lotus",
    "Love in a mist",
    "Magnolia",
    "Mallow", 
    "Marigold",
    "Mexican Aster",
    "Mexican Petunia",
    "Monkshood",
    "Moon Orchid",
    "Morning Glory",
    "Orange Dahlia",
    "Osteospermum",
    "Oxeye daisy",
    "Passion flower",
    "Pelargonium", 
    "Peruvian lily",
    "Petunia",
    "Pincushion flower",
    "Pink-Yellow Dahlia",
    "Pink Evening Primrose",
    "Poinsettia", 
    "Primula",
    "Prince-of-Wales Feather",
    "Purple coneflower",
    "Red Ginger",
    "Rose",
    "Ruby-Lipped Cattleya",
    "Siam tulip",
    "Silverbush",
    "Snapdragon",
    "Spear Thistle",
    "Spring Crocus",
    "Stemless Gentian",
    "Sunflower",
    "Sweetpea",
    "Sweet William",
    "Sword lily",
    "Thorn-apple",
    "Tiger lily",
    "Toad Lily",
    "Tree mallow",
    "Tree Poppy",
    "Trumpet Creeper",
    "Wallflower", 
    "Water Lily",
    "Watercress", 
    "Wild Pansy",
    "Wind flower",
    "Yellow iris"
]

export default flowers;